"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyUtils = void 0;
var copy = require("copy-to-clipboard");
var notification_1 = require("./notification");
/** CopyUtils class. */
var CopyUtils = /** @class */ (function () {
    function CopyUtils() {
    }
    /**
     * copy
     * @param text string
     * @param description string
     */
    CopyUtils.copy = function (text, description) {
        copy(text);
        notification_1.NotificationUtils.notify({
            title: 'Success',
            message: description != null ? "Copied ".concat(description) : 'Copied text',
            level: 'info',
            autoDismiss: 5,
        });
    };
    return CopyUtils;
}());
exports.CopyUtils = CopyUtils;
//# sourceMappingURL=copy.js.map